import axios from "axios";

export const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
export const API = `${BACKEND_URL}/api`;

/** Resolve a stored photo_url (which can be absolute http URL or relative /api/photos/…) into an absolute URL usable in <img src>. */
export function resolvePhotoUrl(url) {
  if (typeof url !== "string") return null;
  const normalized = url.trim();
  if (!normalized || ["null", "undefined"].includes(normalized.toLowerCase())) return null;
  if (/^https?:\/\//i.test(normalized)) return normalized;
  if (normalized.startsWith("/api/")) return `${BACKEND_URL}${normalized}`;
  return normalized;
}

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatError(err) {
  if (err?.response?.status === 413) {
    return "The selected file is too large to upload. Choose a smaller photo and try again.";
  }
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(d);
}
